import { createI18n } from 'vue-i18n'
import en from './en.json'

export const SUPPORT_LOCALES = ['en'] as const
export type SupportLocale = typeof SUPPORT_LOCALES[number]

export const DEFAULT_LOCALE: SupportLocale = 'en'

const messages = {
  en,
}

function getInitialLocale(): SupportLocale {
  // Check localStorage first
  const storedLocale = localStorage.getItem('locale') as SupportLocale
  if (storedLocale && SUPPORT_LOCALES.includes(storedLocale)) {
    return storedLocale
  }

  // Check browser language
  const browserLocale = navigator.language.split('-')[0] as SupportLocale
  if (SUPPORT_LOCALES.includes(browserLocale)) {
    return browserLocale
  }

  return DEFAULT_LOCALE
}

export const i18n = createI18n({
  locale: getInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages,
  legacy: false, // Use Composition API mode
})

export function setLocale(locale: SupportLocale) {
  if (SUPPORT_LOCALES.includes(locale)) {
    i18n.global.locale.value = locale
    localStorage.setItem('locale', locale)
    document.documentElement.lang = locale
  }
}

export default i18n